export const FIND_PORTAL_TITLE = 'Find your portal';
export const FIND_PORTAL_BODY = "We'll take you to your servicer's portal to sign in.";

export const EMAIL_LABEL = 'Email';
export const CONTINUE = 'Continue';
export const EMAIL_FOOTER =
  "Willow never asks for a password on this page. You'll sign in on your servicer's own portal.";

export const CHECKING_TITLE = 'Checking your email';

// The tab title stays generic, so the lender's name does not linger in browser history.
export const SINGLE_DOCUMENT_TITLE = 'Taking you to your portal';
export const SINGLE_TITLE = (name: string) => `Taking you to ${name}`;
export const SINGLE_BODY = 'Your email will already be filled in.';
export const GO_NOW = 'Go now';
export const USE_DIFFERENT_EMAIL = 'Use a different email';

export const MULTI_TITLE = 'Which portal?';
export const MULTI_BODY = 'Choose where you want to sign in.';

export const NONE_TITLE = 'Next step is in your inbox';
export const NONE_BODY = "Your servicer's portal has its own address.";
export const NONE_STEP_1 = 'Open the email your mortgage statements come from and use the portal link in it.';
export const NONE_STEP_2 = 'Or contact your servicer and ask for their portal address.';
export const TRY_ANOTHER_EMAIL = 'Try another email';

// Duration-neutral on purpose: the per-email window is an hour, so a title that names
// minutes would contradict the countdown underneath it.
export const LIMITED_TITLE = 'Paused for now';
export const LIMITED_BODY = 'Meanwhile, the portal link in your statement email still works.';
export const LIMITED_CAPTION = 'until you can try again';
export const LIMITED_FOOTER = 'Need help now? Call your servicer directly.';

export const LOOKUP_FAILED_TITLE = 'We could not check that email right now.';
export const LOOKUP_FAILED_SUBTITLE = 'Please try again in a moment.';
export const DEFAULT_HOST_LABEL = 'portal.willowservicing.com';
